
const Home = () => {
  return (
    <div className="page">
      <h1>Resume Creator</h1>
      <h2>Welcome to the Resume Creator!</h2>
      <h3>Press "Next" to continue</h3>
    </div>
  );
};

export default Home;
